module.exports = __webpack_public_path__ + "img/novo_rio_pinheiros.8928d80d.png";